import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M63.0301 12.2C56.3101 4.17 48.11 1 35.12 1C22.13 1 13.38 4.67 7.09002 12.2C-3.60998 25.01 3.61004 52.55 3.61004 52.55C3.61004 52.55 4.36011 30.09 12.5601 23.44C19.5501 17.78 25.9601 19.95 35.0601 19.95C44.1601 19.95 50.5801 17.78 57.5601 23.44C65.7601 30.09 66.5101 52.55 66.5101 52.55C66.5101 52.55 73.7401 25 63.0301 12.2Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M6.6998 12.2C6.6998 12.2 0.419867 23.95 6.01987 36.15"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M63.4199 12.2C63.4199 12.2 69.6999 23.95 64.0999 36.15"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M35.0601 19.94V1" stroke={outline} strokeMiterlimit="10" />
      <path
        d="M18.0001 4.5C18.0001 4.5 10.9002 10.22 10.6802 25.2"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M24.77 2.36011C24.77 2.36011 17.5 8.03011 17.5 20.3601"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M27.8 1.86011C27.8 1.86011 24.2799 6.92011 24.7199 19.0301"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M55.49 6.32007C55.49 6.32007 61.92 14.0301 62.14 29.0001"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M45.4102 2.36011C45.4102 2.36011 52.6802 8.03011 52.6802 20.3601"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M39.8999 1.86011C39.8999 1.86011 43.4199 6.92011 42.9799 19.0301"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M41.3901 2.03003C41.3901 2.03003 44.9101 7.09003 44.4701 19.2"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M34.9994 5.98996L35.0082 5.99015L35.0171 5.99002C35.0595 5.98942 35.1177 5.98797 35.1909 5.98613C37.284 5.93373 51.6424 5.57428 61.0969 16.1997C56.4883 12.5257 48.4921 8.80883 35.0107 8.79007L35.0093 8.79007C21.5267 8.80883 13.5303 12.5264 8.92186 16.2007C18.4293 5.5126 32.8973 5.92964 34.8598 5.98621C34.9172 5.98786 34.9639 5.98921 34.9994 5.98996Z"
        fill="white"
        stroke={outline}
      />
    </g>
  )
}
